export default {
  heading: "设定新密码",
  intro: "请为您的教城帐户{id}设定新密码。",
  submitBtn: "确定",
  resetBtn: "重设",
  closeBtn: "关闭",
  completed:
    "您已成功设定新密码。",
  recordNotFound: "很抱歉，您输入的网址有误。<br>请检查网址连结是否正确。如需协助，请电邮至 <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a> 。",
  backToHome: "返回主页",
  hasChanged: "您已利用此连结设定新密码。连结已失效。",
  expired: "连结已超时失效。",
  userNotFound: "系统找不到您的帐户，请联繫您的学校管理员检查帐户。",

};
